<gl-search
  small
  extend
  [attr.dropdown]="dropdownVisible ? true : null"
  [options]="searchResults"
  [placeholder]="'actions.searchPlaceholder' | translate"
  (onKeyup)="onKeyup($event.detail.value)"
  (onSelected)="onSelected($event.detail.value)"
  (onClose)="onKeyup('')"
>
</gl-search>
